export default __webpack_public_path__ + "static/media/lightModeConvert.89094129.png";